import { compose, groupBy, filter, flatten, map, keys } from 'ramda'
import { LayerGroup, Layer as LayerModel } from 'models/layer'
import { SymbolLayout } from 'mapbox-gl'
import { PointIcons } from 'models/custom-layer'
import { StorageProvider } from 'providers/storage'

type MapLayer = { [key: string]: LayerModel[] }
export const buildMapLayers = (layers: LayerGroup[], activeLayers: number[]): MapLayer =>
  compose(
    groupBy((layer: LayerModel) => layer.viz.source),
    filter((layer: LayerModel) => activeLayers?.includes(layer.id) && layer?.viz?.source),
    flatten,
    map((layer: LayerGroup) => layer.layers),
  )(layers)

export const buildMapLayersIcons = (layers: LayerGroup[]) =>
  compose(
    keys(),
    groupBy((layer: LayerModel) => (layer.viz.layout as SymbolLayout)['icon-image']),
    filter((layer: LayerModel) => {
      const layout = layer?.viz?.layout as SymbolLayout
      if (!layout) return false

      const icon = layout['icon-image'] ?? null
      return !Object.values(PointIcons).includes(icon as PointIcons)
    }),
    flatten,
    map((layer: LayerGroup) => layer.layers),
  )(layers)

export const buildTilesUrl = (
  source: string,
  projectId: string,
  areaId: string,
  flagCorte: string,
) => {
  const url = new URL(source)

  if (projectId) {
    url.searchParams.set('projectId', projectId)
  }

  if (areaId) {
    url.searchParams.set('areasIds', areaId)
  }

  url.searchParams.set('uemail', StorageProvider.get('email'))

  url.searchParams.set('clipped', flagCorte)

  console.log(url)
  return decodeURI(url.toString())
}

export const getFilterExpression = (layer: LayerModel, filters: any) => {
  const layerSourceId = layer.viz['source-layer']

  // const column = filters[layerSourceId] ? Object.keys(filters[layerSourceId])[0] : null

  //if (column && filters[layerSourceId][column].filter.length > 3) {
  // console.log(column)
  //const column = Object.keys(filters[layerSourceId])[0]
  // return ['in', ['get', column], ['literal', filters[layerSourceId][column].filter]]
  //}

  try {
    let resfilter = [
      'all',
      ['==', ['get', 'id'], ['get', 'id']],
      //["in", ['get', columnname], ['literal', filters[layerSourceId][column].filter]]
    ]

    for (let column in Object.keys(filters[layerSourceId])) {
      let columnname = Object.keys(filters[layerSourceId])[column]
      console.log(columnname)

      if (
        filters[layerSourceId][columnname].filter.toString() !== '[]' &&
        filters[layerSourceId][columnname].filter.toString() !== '[,]' &&
        filters[layerSourceId][columnname].filter.toString() !== '' &&
        filters[layerSourceId][columnname].filter.toString() !== '[ ]'
      ) {
        console.log(columnname + ' tiene valores en su filtro')
        resfilter.push([
          'in',
          ['get', columnname],
          ['literal', filters[layerSourceId][columnname].filter],
        ])
      }
      console.log(resfilter)
    }

    return resfilter
  } catch (exception) {
    //console.log(exception)
  }
  return ['literal', true]
}

export const transformRequest = (url = '', resourceType?: string) => {
  const mapserverUrl = process.env.REACT_APP_MAP_SERVER_URL!
  const shouldOverride = resourceType === 'Tile' && url.startsWith(mapserverUrl)

  if (shouldOverride) {
    return {
      url: url,
      headers: { Authorization: 'JWT ' + StorageProvider.get('token') },
    }
  }

  return { url }
}
